export function SignalIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M15.2426 3.75738C17.5858 6.10053 17.5858 9.89952 15.2426 12.2427M6.75736 12.2426C4.41421 9.89948 4.41421 6.10049 6.75736 3.75735M3.92893 15.0711C0.0236893 11.1658 0.0236893 4.8342 3.92893 0.928955M18.0711 0.929001C21.9763 4.83424 21.9763 11.1659 18.0711 15.0711M13 8.00002C13 9.10459 12.1046 10 11 10C9.89543 10 9 9.10459 9 8.00002C9 6.89545 9.89543 6.00002 11 6.00002C12.1046 6.00002 13 6.89545 13 8.00002Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
